import React from 'react';
import { Col } from 'antd';
import { OrganizationFormItem } from '@/components/views/Resolution886/components/Form';

export function Organization(): JSX.Element {
	return (
		<Col xs={24}>
			<OrganizationFormItem fieldName="organization_id" required={false} />
		</Col>
	);
}
